import { configureStore } from '@reduxjs/toolkit'
import Auth from './reducers/auth'
import Globals from './reducers/globals'
import User from './reducers/user'
import Modal from './reducers/modal'
import QrCode from './reducers/qrcode'

export const store = configureStore({
    reducer: {
        Auth,
        Globals,
        User,
        Modal,
        QrCode
    },
})